import {X} from "react-feather";

export const ModalReadMore = ({title, text, onHandleClose}) => {

    return (
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    {title}
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleClose}>
                    <X/>
                </div>
            </div>

            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">
                    <div
                        className="sl-break-words-anywhere sl-text-md sl-font-normal sl-text-gray-700 sl-max-h-112 overflow-y-auto sl-customized-scrollbar">
                        {text}
                    </div>
                </div>
            </div>

            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleClose}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalReadMore;
